<div class="scroll-area">
    <form #formBuilding="ngForm">
        <div class="tab-container">

            <div class="input-group">
                <label for="heatingLocation">Standort Heizanlage*</label>
                <input type="text" placeholder="Info eingeben"
                       required
                       name="heatingLocation"
                       id="heatingLocation"
                       [(ngModel)]="model.heatingLocation">
            </div>

            <div class="input-group">
                <label for="contactPersonName">Name Ansprechpartner*</label>
                <input type="text" placeholder="Name eingeben"
                       required
                       name="contactPersonName"
                       id="contactPersonName"
                       [(ngModel)]="model.contactPersonName">
            </div>

            <div class="input-group">
                <label for="contactPersonNumber">Telefonnummer Ansprechpartner</label>
                <input type="text" placeholder="Telefonnummer eingeben"
                       name="contactPersonNumber"
                       id="contactPersonNumber"
                       [(ngModel)]="model.contactPersonNumber">
            </div>

            <div class="inputs-columns-container align-items-end">
                <div class="input-group">
                    <label for="heatingType">Hauptzählerstand (Gas oder Fernwärme)</label>
                    <input type="number" placeholder="Hauptzählerstand eingeben"
                           name="heatingType"
                           id="heatingType"
                           [(ngModel)]="model.mainMeterReading">
                </div>

                <div class="input-group">
                    <label [for]="'mainMeterReadingUnit'">Einheit</label>
                    <select [name]="'mainMeterReadingUnit'"
                            [id]="'mainMeterReadingUnit'"
                            [(ngModel)]="model.mainMeterReadingUnit">
                        <option [value]="'m3'">m³</option>
                        <option [value]="'l'">l</option>
                        <option [value]="'kWh'">kWh</option>
                        <option [value]="'MWh'">MWh</option>
                    </select>
                </div>
            </div>
        </div>
    </form>
</div>
<app-navigation-footer
        [isBackLinkDisabled]="false"
        [backLink]="'/gateway/general/sending'"
        [isNextLinkDisabled]="!validationService.isBuildingValid(model)"
        [nextLink]="'/gateway/heating/information'"
        [isLast]="false"
></app-navigation-footer>
